import { captureProductEvent } from "@/lib/analytics";

export const telemetryService = {
  async track(data: {
    tenantId: string;
    action: string;
    entityType: string;
    entityId?: string;
    metadata?: Record<string, unknown>;
    newValue?: Record<string, unknown>;
  }): Promise<void> {
    // Auditoria autoritativa fica nas Edge Functions; o cliente só emite telemetria não crítica.
    captureProductEvent(data.action, {
      tenant_id: data.tenantId,
      entity_type: data.entityType,
      entity_id: data.entityId ?? null,
      ...(data.metadata ?? {}),
      new_value: data.newValue ?? null,
    });
  },
};
